/**
 * PackageAssignCell — the Scheduler row's Package column. Library trackers
 * get the editable cell (badge → select → confirm). A tracker whose
 * optimizer capability is off shows its package read-only:
 * the badge, or "—" — never an editor, so no apply/unassign request.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { LibraryPackageCell, PackageBadge } from '@/features/flow-optimizer-library/scheduler/cell';
import type { OptimizerRow } from '@/features/optimizer-center/optimizer-center.types';
import { libraryProviderOf } from '@/features/trackers/flow-optimizer/library-provider';

export interface PackageAssignCellProps {
  row: OptimizerRow;
  canEdit: boolean;
}

const PackageAssignCell: FC<PackageAssignCellProps> = ({ row, canEdit }) => {
  const provider = libraryProviderOf(row.provider);
  if (provider) return <LibraryPackageCell row={row} provider={provider} canEdit={canEdit} />;
  if (!row.package) return <span className="text-muted-foreground">—</span>;
  return <PackageBadge pkg={row.package} />;
};

export default PackageAssignCell;
